let cachedConfig = null;
let loadingPromise = null;

export const loadConfig = async () => {
    if (cachedConfig) return cachedConfig;
    if (loadingPromise) return loadingPromise;

    loadingPromise = fetch('/config/config.json')
        .then(res => res.json())
        .then(config => {
            cachedConfig = config;
            return config;
        })
        .catch(err => {
            console.error('Failed to load config:', err);
            loadingPromise = null;
            throw err;
        });

    return loadingPromise;
};

export const getConfig = () => cachedConfig;
